/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
document.addEventListener("DOMContentLoaded", function(event) { 
// debugger;
  try{
    var swiper = new Swiper('.productCustomSlider .swiper-container', {
      direction: 'vertical',
      resistanceRatio: 0,
      //freeMode: true,
      // according to the codepen
      mousewheel: {
        releaseOnEdges: true,
      },
  //      noSwiping:true,
  //      noSwipingClass: 'swiper-no-swiping',

      pagination: {
        el: '.productCustomSlider .swiper-pagination',
        type: 'bullets',
        clickable : true
      },
      on: {
        touchMove: function (swiper, event) {
        },
        slideChange : function(swiper) {
          var slides_arr_size = swiper.slides.length - 1;
          var slideChange  = swiper.activeIndex;
          var PageContainerElem = document.querySelector('.PageContainer');

  //         if(slideChange != slides_arr_size) {
  //           if(PageContainerElem) {
  //             console.log(11);
  //             PageContainerElem.classList.add('hide_top_elems');
  //           }
  //         }

  //         if(slideChange == slides_arr_size) {
  //           if(PageContainerElem) {
  //             PageContainerElem.classList.remove('hide_top_elems');
  //           }
  //         } else {
  //           if(PageContainerElem) {
  //             PageContainerElem.classList.add('hide_top_elems');
  //           }
  //         }
        }
      }
    });
  }
  catch(err){
  }

  function getPosition(element) {
    var xPosition = 0;
    var yPosition = 0;

    while(element) {
      xPosition += (element.offsetLeft - element.scrollLeft + element.clientLeft);
      yPosition += (element.offsetTop - element.scrollTop + element.clientTop);
      element = element.offsetParent;
    }

    return { x: xPosition, y: yPosition };
  }


  var ProductMeta_MobileFixedElem =  document.querySelector('.ProductMeta_MobileFixed');
  if(ProductMeta_MobileFixedElem) {
    function ProductMetaFixedMobile () {
      if(window.innerWidth < 641) {
        var windowScroll = window.scrollY + window.innerHeight;
        var ProductMeta_MobileFixedElem =  document.querySelector('.ProductMeta_MobileFixed');
        var ProductMeta = document.querySelector('.ProductMeta_MobileFixedParent');
        var offsetTop = getPosition(ProductMeta).y;
        var PageContainerElem = document.querySelector('.PageContainer');


        if(PageContainerElem) {
          if(window.scrollY > 0) {
            PageContainerElem.classList.remove('hide_top_elems');
          } else {
            PageContainerElem.classList.add('hide_top_elems');
          }
        }

        
        if(windowScroll >= offsetTop) {          
          ProductMeta_MobileFixedElem.classList.remove('active');
        } else {
          ProductMeta_MobileFixedElem.classList.add('active');
        }
      }
    };

    ProductMetaFixedMobile();
    window.onscroll = function() {
      ProductMetaFixedMobile();
    };

  }
});

$(document).ready(function(){
  
    
    sectiona = '#shopify-section-1610531006077751b4';
  
    html = '<div id="shopify-section-1610531006077751b4cc" class="shopify-section shopify-section--bordered" style="background-color: #fff;">';
    html += '<section class="Section Section--spacingNormal">';
    html += ' <div class="FeatureText " >';
    html += '    <div class="FeatureText__ContentWrapper" style="background-color: #fff;padding-left: 0;padding-right: 0;">';
    html += '<div class="FeatureText__Content" style="background-color: #fff;max-width:1920px !important">';
    html += '<header class="SectionHeader">';
    html += '<div class="SectionHeader__Description Rte" id="instantbuysection" style="max-width:1920px !important">';
    if(detectMob())
      html += '<img src="https://promo.davinospose.it/wp-content/uploads/2023/07/Screenshot-2023-07-18-alle-16.54.08.jpg">';
    else
      html += '<img src="https://promo.davinospose.it/wp-content/uploads/2023/07/BANNER-saldi-estivi-davino-cerimonia-–-4.jpg">';
    //html += '<a href="https://promo.davinospose.it/instant-buy" id="btninstantbuy" target="_blank" class="Button Button--primary" style="border-color: #beac77;background-color: #beac77;margin-left: 180px;">scopri di più</a>';
    html += '</div>';
    html += '</header>';
    html += '</div>';
    html += '</div>';
    html += '</div>';
    html += '</section>';
    html += '</div>';

    if($(sectiona)){
        $( html ).insertAfter( sectiona );
        w = $("#instantbuysection").width();
        margine = (w/2)-87;
        console.log(margine);
        //$("#btninstantbuy").css("margin-left",margine);
        //$("#btninstantbuy").css("max-width","1920px!important");
    }

});

function detectMob() {
    return (  window.innerWidth <= 800  );
  }

$(document).ready(function(){
  setTimeout(function(){
    mb = parseInt($('div[class^="Bubble__BubbleComponent-sc-"]').css("margin-bottom"));
    mb = mb + 40;
    $('div[class^="Bubble__BubbleComponent-sc-"]').css("margin-bottom",mb+"px");
    console.log(mb);
  },1000);
});

